/**
 * Definicja globalnych parametrów systemu
 * 
 * id                   -   identyfikator
 * 
 */
export const GlobalParam = {
    //Wersje kompatybilne flow-server. Jesli wiecej jak jedna to rozdzialmy przecinkiem.
    FLOW_SERVER_COMPATIBILITY: {
        id: 1
    },
    // Wersje testowe DEMO i np 1,1059.
    FLOW_DEMO_VERSION: {
        id: 2
    },
    //Kod DEMO.
    FLOW_DEMO_CODE: {
        id: 3
    }
};